const PROJ_KEY_PATTERN = /^sk-proj-[A-Za-z0-9_\-.]+$/;
const REGULAR_KEY_PATTERN = /^sk-[A-Za-z0-9_\-.]+$/;
const SK_PROJ_KEY_PREFIX = 'sk-proj-';
const SK_KEY_PREFIX = 'sk-';
export const apiKeyValidator = key => {
  if (!key.trim()) {
    return false;
  }
  if (key.startsWith(SK_PROJ_KEY_PREFIX)) {
    return PROJ_KEY_PATTERN.test(key);
  }
  if (key.startsWith(SK_KEY_PREFIX)) {
    return REGULAR_KEY_PATTERN.test(key);
  }
  return false;
};